export class AppError extends Error {
    /*public code?: string;
    public data?: unknown;
    public override cause?: unknown;*/

    constructor(
        message: string,
        options?: {
            code?: string;
            data?: unknown;
            cause?: unknown;
        }
    ) {
        super(message, options);
        this.name = 'AppError';
        /*this.code = options?.code;
        this.data = options?.data;
        this.cause = options?.cause;*/

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AppError);
        }
    }
}
